import { Box, SxProps, Theme } from '@mui/material';

import { WhatIsACareerTrackModalContent } from './WhatIsACareerTrackModalContent';

export const CareerTrackPage = () => {
  return (
    <Box sx={containerStyle}>
      <WhatIsACareerTrackModalContent />
    </Box>
  );
};

const containerStyle: SxProps<Theme> = ({ backrs }) => ({
  flexGrow: 1,
  bgcolor: backrs.colors['Brand/25'],
  containerType: 'inline-size',
});
